module.exports = __webpack_public_path__ + "static/media/loader.5e9a1071.svg";